// SIPBenefits.jsx
import React from 'react';
import './SipBenefitsCards.scss';

import taxPercentIcon from '../../public/images/sip-select/tax_percent.png';
import benefitPlantIcon from '../../public/images/sip-select/benefit_plant.png';

const SipBenefitsCards = () => {

  return (
    <div className="sip-benefits-container">
      <span className="sip-benefits-heading">Benefits of SIP donations?</span>

      <div className="sip-benefits-cards">
        {/* Tax Benefits Card */}
        <div className="sip-tax-card">
          <div className='vector-1'>
            <svg width="152" height="87" viewBox="0 0 152 87" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path id="Vector" opacity="0.2" fillRule="evenodd" clipRule="evenodd" d="M54.1006 -52.6678C83.5873 -53.9224 115.894 -52.5021 135.212 -32.6497C155.203 -12.1055 154.241 17.3447 148.134 43.9658C141.798 71.5845 131.076 102.168 101.805 112.977C73.5206 123.422 45.0155 104.42 17.6799 92.1389C-8.62847 80.3195 -40.507 70.9521 -48.1105 45.6258C-55.9077 19.6544 -38.3516 -6.4027 -17.8296 -26.1381C0.712261 -43.9693 26.8228 -51.5071 54.1006 -52.6678Z" fill="url(#paint0_linear_7947_8120)" />
              <defs>
                <linearGradient id="paint0_linear_7947_8120" x1="51.5025" y1="-46.7407" x2="73.9516" y2="106.106" gradientUnits="userSpaceOnUse">
                  <stop stopColor="white" />
                  <stop offset="1" stopColor="white" stopOpacity="0" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div className='vector-2'>
            <svg xmlns="http://www.w3.org/2000/svg" width="99" height="64" viewBox="0 0 99 64" fill="none">
              <path opacity="0.3" fillRule="evenodd" clipRule="evenodd" d="M146.451 101.465C139.609 118.64 128.29 134.243 109.169 141.498C89.7368 148.871 65.9471 148.843 45.0484 139.938C25.2736 131.513 12.0111 114.479 4.29591 96.8143C-2.50121 81.2519 2.47311 66.2442 6.20681 51.0078C10.5182 33.4139 8.92178 10.9149 27.2349 3.2052C45.8031 -4.61192 68.7472 8.52745 89.6882 15.8626C110.98 23.3204 135.931 27.9088 147.479 45.3237C159.333 63.2007 153.533 83.6837 146.451 101.465Z" fill="url(#paint0_linear_7947_8121)" />
              <defs>
                <linearGradient id="paint0_linear_7947_8121" x1="157.077" y1="101.159" x2="-13.9768" y2="48.9353" gradientUnits="userSpaceOnUse">
                  <stop stopColor="white" stopOpacity="0.5" />
                  <stop offset="1" stopColor="white" stopOpacity="0" />
                </linearGradient>
              </defs>
            </svg>
          </div>

          <div className="card-content">
            <div className="icon-wrapper">
              <img src={taxPercentIcon} alt="tax_percent" />
            </div>
            <div className="text-content">
              <span>Get Upto 50% tax benefits under 80G</span>
              <p>Buy SIP for upto 50% rebate</p>
            </div>
          </div>
        </div>

        {/* General Benefits Card */}
        <div className="sip-benefit-card">
          <div className='vector-1'>
            <svg width="152" height="87" viewBox="0 0 152 87" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path id="Vector" opacity="0.2" fillRule="evenodd" clipRule="evenodd" d="M54.1006 -52.6678C83.5873 -53.9224 115.894 -52.5021 135.212 -32.6497C155.203 -12.1055 154.241 17.3447 148.134 43.9658C141.798 71.5845 131.076 102.168 101.805 112.977C73.5206 123.422 45.0155 104.42 17.6799 92.1389C-8.62847 80.3195 -40.507 70.9521 -48.1105 45.6258C-55.9077 19.6544 -38.3516 -6.4027 -17.8296 -26.1381C0.712261 -43.9693 26.8228 -51.5071 54.1006 -52.6678Z" fill="url(#paint0_linear_7947_8120)" />
              <defs>
                <linearGradient id="paint0_linear_7947_8120" x1="51.5025" y1="-46.7407" x2="73.9516" y2="106.106" gradientUnits="userSpaceOnUse">
                  <stop stopColor="white" />
                  <stop offset="1" stopColor="white" stopOpacity="0" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div className='vector-2'>
            <svg xmlns="http://www.w3.org/2000/svg" width="99" height="64" viewBox="0 0 99 64" fill="none">
              <path opacity="0.3" fillRule="evenodd" clipRule="evenodd" d="M146.451 101.465C139.609 118.64 128.29 134.243 109.169 141.498C89.7368 148.871 65.9471 148.843 45.0484 139.938C25.2736 131.513 12.0111 114.479 4.29591 96.8143C-2.50121 81.2519 2.47311 66.2442 6.20681 51.0078C10.5182 33.4139 8.92178 10.9149 27.2349 3.2052C45.8031 -4.61192 68.7472 8.52745 89.6882 15.8626C110.98 23.3204 135.931 27.9088 147.479 45.3237C159.333 63.2007 153.533 83.6837 146.451 101.465Z" fill="url(#paint0_linear_7947_8121)" />
              <defs>
                <linearGradient id="paint0_linear_7947_8121" x1="157.077" y1="101.159" x2="-13.9768" y2="48.9353" gradientUnits="userSpaceOnUse">
                  <stop stopColor="white" stopOpacity="0.5" />
                  <stop offset="1" stopColor="white" stopOpacity="0" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div className="card-content">
            <div className="icon-wrapper">
              <img src={benefitPlantIcon} alt="plant" />
            </div>
            <div className="text-content">
              <span>Get SIP benefits by donating now</span>
              <p>Buy SIP to avail offers</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SipBenefitsCards;